export const heroData = {
  tag: "🔥 全网最全吃瓜平台",
  h1: "91黑料网 — 一站式吃瓜爆料平台",
  slogan: "最新黑料 · 最快爆料 · 最全吃瓜",
  description: "91黑料网是国内领先的娱乐爆料与热点吃瓜聚合平台，每日更新涵盖娱乐圈、网红圈、社会热点等多领域最新黑料信息。我们汇集全网最具话题性的视频爆料资源，提供实时更新的网站入口与App下载通道，确保你第一时间获取最新爆料内容。无论是明星八卦、网红翻车还是热点事件内幕，91黑料网为你一站式呈现最全吃瓜现场。",
  stats: [
    { value: "24h", label: "全天候实时追踪" },
    { value: "5000+", label: "累计爆料内容" },
    { value: "98%", label: "入口可用率" },
  ],
  primaryCta: { text: "立即吃瓜", href: "#cards" },
  secondaryCta: { text: "下载App", href: "#app" },
};

export const appEntryData = {
  id: "app",
  title: "91黑料网 App 下载",
  subtitle: "手机随时吃瓜，爆料不错过",
  description: "91黑料网App现已支持Android与iOS双平台下载，提供更流畅的浏览体验与独家推送功能。安装后即可第一时间接收热点爆料通知，支持离线缓存视频内容，更有专属评论区互动功能。",
  badge: "最新版本 v3.8.2",
  iosLabel: "iOS 下载",
  androidLabel: "Android 下载",
};

export const cardsData = {
  id: "cards",
  title: "热门爆料",
  subtitle: "最新最热，一网打尽",
  items: [
    {
      title: "某顶流艺人深夜密会曝光",
      summary: "近日有网友拍到某顶流男艺人与神秘女子深夜同返公寓，引发全网热议，粉丝集体炸锅。",
      tag: "娱乐圈",
      time: "2小时前",
      heat: "128万",
    },
    {
      title: "知名网红直播翻车全过程",
      summary: "千万粉丝网红直播带货时因产品问题当场翻车，品牌方紧急回应，评论区彻底沦陷。",
      tag: "网红圈",
      time: "5小时前",
      heat: "96万",
    },
    {
      title: "某综艺后台冲突视频流出",
      summary: "热门综艺录制现场两名嘉宾发生激烈口角，冲突视频被工作人员外泄，节目组保持沉默。",
      tag: "综艺",
      time: "8小时前",
      heat: "215万",
    },
    {
      title: "品牌代言人解约内幕披露",
      summary: "某国际品牌突然宣布与代言人解约，背后原因据传与近期负面事件相关，多方说法不一。",
      tag: "商业",
      time: "12小时前",
      heat: "73万",
    },
    {
      title: "影视剧组拖欠薪资爆料",
      summary: "某在拍大制作剧组被曝拖欠演职人员薪资长达三个月，业内人士纷纷声援维权。",
      tag: "影视",
      time: "1天前",
      heat: "156万",
    },
    {
      title: "音乐节后台私密对话录音",
      summary: "某大型音乐节后台一段私密对话录音被曝光，涉及多位艺人私下评价同行，内容劲爆。",
      tag: "音乐",
      time: "1天前",
      heat: "189万",
    },
  ],
};

export const mediaData = {
  id: "media",
  title: "视频爆料站",
  subtitle: "高清实拍，眼见为实",
  items: [
    {
      title: "某艺人机场遭围堵全程录像",
      desc: "粉丝机场围堵导致秩序混乱，当事人态度引发争议",
      duration: "03:42",
      views: "326万",
      tag: "实拍",
    },
    {
      title: "直播间争吵名场面合集",
      desc: "多位主播直播间内互撕名场面，吃瓜群众直呼过瘾",
      duration: "08:15",
      views: "512万",
      tag: "直播",
    },
    {
      title: "某综艺未播花絮流出",
      desc: "节目组剪辑掉的尴尬片段被内部人员外泄，内容尺度惊人",
      duration: "05:28",
      views: "438万",
      tag: "花絮",
    },
    {
      title: "网红探店造假证据视频",
      desc: "知名探店博主被曝收费刷好评，暗访视频揭穿产业链内幕",
      duration: "11:03",
      views: "267万",
      tag: "暗访",
    },
    {
      title: "某品牌发布会事故现场",
      desc: "新品发布会现场突发技术故障，品牌高层当场黑脸离场",
      duration: "02:56",
      views: "189万",
      tag: "现场",
    },
  ],
};

export const aboutData = {
  id: "about",
  title: "关于91黑料网",
  subtitle: "做最专业的吃瓜爆料平台",
  paragraphs: [
    "91黑料网成立于2020年，是国内领先的娱乐爆料与热点吃瓜聚合平台。我们致力于为全网吃瓜群众提供最新、最全、最真实的爆料内容，涵盖娱乐圈、网红圈、综艺影视、社会热点等多个领域。",
    "平台每日更新超过200条最新爆料，拥有专业的采编团队与智能推荐系统，确保用户在第一时间获取最有价值的热点信息。同时提供视频爆料、图文深度报道、话题讨论等多种内容形式。",
    "我们始终坚持内容真实性为首要准则，所有爆料均经过多方核实后发布。同时为保护爆料人隐私，平台严格实行匿名投稿机制。欢迎广大网友通过投稿通道分享你所知道的内幕信息。",
  ],
};

export const topicsData = {
  id: "topics",
  title: "热门话题",
  subtitle: "吃瓜风向标，热度一目了然",
  items: [
    { name: "#某顶流恋情曝光", heat: "🔥 986万" },
    { name: "#综艺后台冲突事件", heat: "🔥 754万" },
    { name: "#网红带货翻车", heat: "🔥 632万" },
    { name: "#品牌代言人解约潮", heat: "🔥 521万" },
    { name: "#影视圈薪资内幕", heat: "🔥 498万" },
    { name: "#音乐节后台录音", heat: "🔥 467万" },
    { name: "#明星机场冲突", heat: "📈 435万" },
    { name: "#直播带货虚假宣传", heat: "📈 389万" },
    { name: "#综艺剪辑争议", heat: "📈 342万" },
    { name: "#娱乐圈税务问题", heat: "📈 298万" },
    { name: "#粉丝应援乱象", heat: "📈 267万" },
  ],
};

export const faqData = {
  id: "faq",
  title: "常见问题",
  subtitle: "你想知道的都在这里",
  items: [
    {
      question: "91黑料网的内容来源是否可靠？",
      answer: "我们拥有专业的内容审核团队，所有爆料均经过多方交叉验证后发布。对于无法核实的内容，我们会标注「待证实」标签。同时平台设有匿名投稿机制，鼓励知情人士提供真实信息。",
    },
    {
      question: "如何获取91黑料网最新入口地址？",
      answer: "建议收藏本站首页并关注我们的官方社交媒体账号。每次入口更新会第一时间通过站内公告和社交媒体同步推送。也可下载91黑料网App获得更稳定的访问体验。",
    },
    {
      question: "91黑料网App有哪些特色功能？",
      answer: "App支持离线缓存视频、独家推送通知、专属评论区互动、夜间浏览模式等功能。相比网页版，App加载速度更快，浏览体验更流畅，且支持一键分享到各大社交平台。",
    },
    {
      question: "如何在91黑料网投稿爆料？",
      answer: "你可以通过页面底部的「投稿爆料」入口提交信息。我们严格保护爆料人隐私，投稿全程匿名处理。爆料被采纳后，根据内容价值可获得相应奖励。",
    },
    {
      question: "91黑料网的内容更新频率如何？",
      answer: "平台保持7×24小时不间断更新，日均新增内容超过200条。重大热点事件发生时，15分钟内即可上线相关报道。我们的编辑团队遍布全国主要城市，确保信息的及时性。",
    },
    {
      question: "遇到不实信息或侵权内容如何投诉？",
      answer: "如发现不实信息或认为内容侵犯了您的合法权益，请通过页面底部联系方式或发送邮件至官方邮箱进行申诉。我们承诺在24小时内完成核实处理。",
    },
  ],
};

export const indexData = {
  id: "index",
  title: "专题索引",
  subtitle: "分类浏览，精准吃瓜",
  items: [
    { name: "娱乐圈", desc: "明星八卦、恋情、合约纠纷", count: "1,286篇" },
    { name: "网红圈", desc: "主播翻车、带货争议、私生活", count: "952篇" },
    { name: "综艺影视", desc: "幕后花絮、剪辑争议、片酬内幕", count: "743篇" },
    { name: "商业品牌", desc: "代言解约、品牌危机、行业黑幕", count: "518篇" },
    { name: "社会热点", desc: "事件追踪、内幕调查、深度报道", count: "1,034篇" },
    { name: "音乐现场", desc: "演唱会事故、音乐节争议、假唱", count: "367篇" },
    { name: "体育赛事", desc: "赛场争议、转会内幕、违规曝光", count: "421篇" },
    { name: "科技数码", desc: "产品翻车、数据泄露、行业爆料", count: "289篇" },
  ],
};

export const featuresData = {
  id: "features",
  title: "平台特色",
  subtitle: "为什么选择91黑料网",
  items: [
    {
      icon: "ri-flashlight-line",
      title: "极速爆料",
      desc: "热点事件发生后15分钟内上线报道，7×24小时全天候追踪，确保你永远快人一步获取最新吃瓜资讯。",
    },
    {
      icon: "ri-shield-check-line",
      title: "真实可靠",
      desc: "专业审核团队多重验证，核实后发布。未证实内容明确标注，让你吃得放心、吃得明白。",
    },
    {
      icon: "ri-smartphone-line",
      title: "多端同步",
      desc: "网页版与App数据实时同步，支持离线缓存、夜间模式、推送通知，随时随地轻松吃瓜。",
    },
  ],
};

export const carouselData = {
  id: "carousel",
  title: "焦点专题",
  subtitle: "深度追踪，全面还原",
  items: [
    {
      title: "某顶流艺人全面塌房事件追踪",
      desc: "从恋情曝光到商业解约，全方位整理该艺人近期所有争议事件的时间线与内幕细节。",
      tag: "深度专题",
      count: "18篇报道",
    },
    {
      title: "2025娱乐圈税务风暴回顾",
      desc: "盘点今年以来因税务问题翻车的明星艺人，深度分析行业乱象与监管趋势。",
      tag: "年度盘点",
      count: "25篇报道",
    },
    {
      title: "直播带货行业大整顿纪实",
      desc: "从头部主播翻车到行业新规出台，完整记录直播带货领域的乱象整治全过程。",
      tag: "行业观察",
      count: "32篇报道",
    },
    {
      title: "粉丝应援经济灰色产业链揭秘",
      desc: "深入调查饭圈集资、数据造假、黄牛倒票等灰色产业链，揭露应援经济背后的真相。",
      tag: "暗访调查",
      count: "14篇报道",
    },
  ],
};

export const rankingData = {
  id: "ranking",
  title: "爆料热度榜",
  subtitle: "大家都在看什么",
  items: [
    { rank: 1, title: "某顶流艺人深夜密会曝光：全网最全时间线整理", heat: "128万热度", trend: "up" },
    { rank: 2, title: "综艺后台冲突视频流出：当事双方身份确认", heat: "96万热度", trend: "up" },
    { rank: 3, title: "知名网红直播翻车：品牌方紧急声明全文", heat: "87万热度", trend: "up" },
    { rank: 4, title: "品牌代言人解约内幕：多方说法大对比", heat: "73万热度", trend: "down" },
    { rank: 5, title: "音乐节后台录音曝光：涉及多位艺人评价", heat: "68万热度", trend: "up" },
    { rank: 6, title: "影视剧组欠薪事件：业内人士集体发声", heat: "55万热度", trend: "new" },
  ],
};

export const contactData = {
  id: "contact",
  title: "投稿爆料",
  subtitle: "你有料，我来爆",
  description: "91黑料网欢迎广大网友投稿爆料。我们严格保护爆料人隐私，投稿全程匿名处理。爆料一经采纳，根据内容价值给予相应奖励。你的每一次爆料，都是推动真相的力量。",
  note: "请确保所提供信息真实有效，虚假信息将不予采纳。",
};

export const updatesData = {
  id: "updates",
  title: "最新动态",
  subtitle: "实时更新，不错过任何风吹草动",
  items: [
    { time: "10分钟前", content: "某知名导演新片片场发生意外，拍摄暂时中断，剧组暂未回应" },
    { time: "35分钟前", content: "某女星社交平台疑似回应近期争议：「清者自清」配图引发猜测" },
    { time: "1小时前", content: "综艺节目组就后台冲突事件发布道歉声明，涉事嘉宾暂未表态" },
    { time: "2小时前", content: "品牌方召开发布会说明代言人解约原因：系正常合约到期" },
    { time: "3小时前", content: "音乐节主办方就后台录音泄露事件报警，警方已介入调查" },
    { time: "4小时前", content: "影视行业协会就欠薪问题发布行业自律倡议书" },
    { time: "5小时前", content: "多位网红主播联合发布声明，呼吁平台规范直播带货行为" },
    { time: "7小时前", content: "某顶流艺人工作室发布律师函，否认近期所有不实传闻" },
    { time: "9小时前", content: "网信办发布最新网络内容管理通知，多家平台响应整改" },
  ],
};

export const commentsData = {
  id: "comments",
  title: "吃瓜热评",
  subtitle: "瓜友们都在说什么",
  items: [
    {
      avatar: "匿",
      nickname: "吃瓜不嫌事大",
      time: "3小时前",
      content: "这个综艺后台冲突的视频我看了三遍，真的太精彩了！没想到平时在镜头前那么和谐的两个人私下关系这么紧张。节目组这次估计也很难收场了。",
      likes: 3286,
    },
    {
      avatar: "名",
      nickname: "娱乐圈纪委",
      time: "5小时前",
      content: "作为业内人透露一下，品牌代言人解约这个事远比表面看起来复杂。涉及的利益方至少有三四个，后续还会有更多细节被爆出来，大家拭目以待。",
      likes: 5612,
    },
    {
      avatar: "瓜",
      nickname: "今日份吃瓜群众",
      time: "8小时前",
      content: "91黑料网真的是我最常刷的吃瓜平台了，更新速度比微博还快，而且内容经得起推敲。这次下载了App体验确实比网页版好很多，推荐大家试试！",
      likes: 1893,
    },
  ],
};

export const footerData = {
  description: "91黑料网 — 国内领先的娱乐爆料与热点吃瓜聚合平台。每日更新最新爆料、视频爆料、深度报道，提供网站入口与App下载。一站直达吃瓜爆料，做最懂你的吃瓜平台。",
  sections: [
    {
      title: "快速导航",
      links: [
        { label: "热门爆料", href: "#cards" },
        { label: "视频爆料站", href: "#media" },
        { label: "焦点专题", href: "#carousel" },
        { label: "热度榜单", href: "#ranking" },
        { label: "最新动态", href: "#updates" },
      ],
    },
    {
      title: "关于我们",
      links: [
        { label: "平台介绍", href: "#about" },
        { label: "常见问题", href: "#faq" },
        { label: "投稿爆料", href: "#contact" },
        { label: "App下载", href: "#app" },
      ],
    },
  ],
  partners: {
    title: "合作伙伴",
  },
};